import styled from 'styled-components';
import Price from './Price';
import { colorSchema } from 'utils/style';

export default styled(Price)`
  .price {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    &--row {
      align-items: flex-end;
      flex-direction: row-reverse;
      justify-content: flex-start;
      .price__number,
      .price__vat {
        margin: 0 0.5rem;
      }
    }

    &--side {
      flex-direction: row;
      justify-content: space-between;
    }

    &--negotiable {
      align-items: center;
    }

    &__number {
      color: ${props =>
        props.small ? colorSchema('grey700') : colorSchema('grey900')};
      font-size: ${props => (props.small ? '1.4rem' : '2rem')};

      &--side {
        color: ${colorSchema('grey900')};
        font-size: 2rem;
        font-weight: bold;
      }

      &--negotiable_amount {
        font-size: 1.6rem;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: ${colorSchema('grey700')};
      }
    }

    &__vat-inc {
      margin-left: 0.5rem;
    }

    &__vat-number,
    &__vat-inc {
      color: ${colorSchema('grey700')};
      font-size: 1.4rem;
    }

    &__vat {
      color: ${colorSchema('grey700')};
      text-align: right;
      font-size: 1.2rem;
    }

    &__negotiable_tag {
      .tag {
        margin-bottom: 0.4rem;
        display: flex;
      }
    }
  }
`;
